import { render } from "./HomePage.vue?vue&type=template&id=67c031c7&scoped=true&ts=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=67c031c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Desktop\\Projekte\\paga-ime\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c031c7"]])

export default __exports__